import { createGenerateClassName, jssPreset, StylesProvider, ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider as MP } from '@material-ui/pickers';
import DateFnsUtils from '@material-ui/pickers/adapter/date-fns';
import { create } from 'jss';
import { ConfirmProvider } from 'material-ui-confirm';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import 'react-day-picker/lib/style.css';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LocalizeProvider } from 'react-localize-redux';
import { Provider } from 'react-redux';
import { api, cookie, theme } from 'utils';
import App from './modules/App';
import { unregister } from './registerServiceWorker';
// import * as serviceWorker from './registerServiceWorker';
import store from './store';
import './styles/index.scss';

const { dispatch } = store;
const jss = create({
    plugins: [...jssPreset().plugins],
});

const generateClassName = createGenerateClassName({
    productionPrefix: 'mpy',
});

const token = cookie.get('tpanel');
const refresh_token = cookie.get('rtpanel');

if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    api.defaults.headers.common['X-REFRESH-TOKEN'] = refresh_token;

    dispatch.auth.verify(token);
}

const render = () => {
    ReactDOM.render(
        <CookiesProvider>
            <LocalizeProvider>
                <HelmetProvider>
                    <MP utils={DateFnsUtils}>
                        <StylesProvider jss={jss} generateClassName={generateClassName}>
                            <SnackbarProvider
                                autoHideDuration={4000}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            >

                                <Provider store={store}>
                                    <ThemeProvider theme={theme}>
                                        <ConfirmProvider>
                                            <App />
                                        </ConfirmProvider>
                                    </ThemeProvider>
                                </Provider>
                            </SnackbarProvider>
                        </StylesProvider>
                    </MP>
                </HelmetProvider>
            </LocalizeProvider>
        </CookiesProvider>,
        document.getElementById('root'),
    );
};

render();

// serviceWorker.register({
//     onUpdate: (registration) => {
//         const waitingServiceWorker = registration.waiting;
//
//         if (waitingServiceWorker) {
//             waitingServiceWorker.addEventListener('statechange', (event) => {
//                 if (event.target.state === 'activated') {
//                     window.location.reload();
//                 }
//             });
//             waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
//         }
//     },
// });

unregister();


// Hot reloading
// eslint-disable
if (module.hot) {
    // Reload shared
    module.hot.accept('./modules/App', () => {
        render();
    });
}
